import { render } from "./index.vue?vue&type=template&id=4b49f353&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=4b49f353&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=4b49f353&scoped=true&lang=css"

import exportComponent from "D:\\work\\cs-player\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b49f353"]])

export default __exports__